  function levenshtein(a, b) {
    const dp = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0))
    for (let i = 0; i <= a.length; i++) dp[i][0] = i
    for (let j = 0; j <= b.length; j++) dp[0][j] = j
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1
        dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost)
      }
    }
    return dp[a.length][b.length]
  }

  function fuzzyMatch(query, text, threshold = 0.7) {
    if (!query || !text) return false
    const q = query.toLowerCase()
    const t = text.toLowerCase()
    if (t.includes(q)) return true 
    const dist = levenshtein(q, t)
    const similarity = 1 - dist / Math.max(q.length, t.length)
    return similarity >= threshold
  }


  export { fuzzyMatch }